export type StepFlowState = 'done' | 'current' | 'pending';

export interface StepFlowItem {
  title: string;
  detail: string;
  state: StepFlowState;
  tone?: 'teal' | 'gold';
}

export default function StepFlow({
  steps,
  className = '',
}: {
  steps: StepFlowItem[];
  className?: string;
}) {
  return (
    <ol className={`steps ${className}`.trim()}>
      {steps.map((step, index) => (
        <li className="contents" key={`${step.title}-${index}`}>
          {index > 0 ? <span className="step-arrow" aria-hidden="true">→</span> : null}
          <span
            className={`step ${
              step.state === 'pending'
                ? 'step-pending'
                : step.state === 'current' && step.tone === 'gold'
                  ? 'step-gold'
                  : ''
            }`.trim()}
            aria-current={step.state === 'current' ? 'step' : undefined}
          >
            <span className="step-num">{step.state === 'done' ? '✓' : index + 1}</span>
            <span>
              <span className="step-title">{step.title}</span>
              <span className="step-detail">{step.detail}</span>
            </span>
          </span>
        </li>
      ))}
    </ol>
  );
}
